(function () {
  var SECTION_SELECTOR = '.clare-section-scrolling-marquee';
  var SET_SELECTOR = '.clare-section-scrolling-marquee__marquee-set';
  var sectionState = new Map();

  function initMarquee(section) {
    var viewport = section.querySelector('[data-marquee]');
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!viewport || !track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var measuring = false;

    // The duplicate set authored in the markup is the template for any extra
    // copies: it is already aria-hidden and carries no reveal classes.
    var template = track.querySelectorAll(SET_SELECTOR)[1];
    if (!template) {
      template = firstSet.cloneNode(true);
      template.removeAttribute('data-marquee-set');
      template.setAttribute('aria-hidden', 'true');
      template.querySelectorAll('.clare-reveal').forEach(function (el) {
        el.classList.remove('clare-reveal');
      });
      template.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('alt', '');
      });
      track.appendChild(template);
    }

    // One set must travel a full set-width + gap before the animation resets.
    // Two sets only hide the seam when a single set is at least as wide as the
    // viewport — otherwise the track runs out of content and a gap appears
    // before the loop. Clone the template until the remaining copies always
    // cover the viewport.
    function syncCopies(distance) {
      var viewportWidth = viewport.clientWidth;
      if (!distance || !viewportWidth) return;

      var needed = Math.max(2, Math.ceil(viewportWidth / distance) + 1);
      var sets = track.querySelectorAll(SET_SELECTOR);

      for (var i = sets.length; i < needed; i++) {
        var copy = template.cloneNode(true);
        copy.removeAttribute('data-marquee-set');
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      }
      for (var j = sets.length - 1; j >= needed; j--) {
        track.removeChild(sets[j]);
      }
    }

    function measure() {
      if (measuring) return;
      measuring = true;

      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = firstSet.scrollWidth + trackGap;

      syncCopies(distance);
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');

      measuring = false;
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      measure();
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    // Watch the viewport (resize) and the set itself (webfont swap, content
    // edits in the theme editor) — both change how many copies are needed.
    var ro = new ResizeObserver(function () {
      measure();
    });
    ro.observe(viewport);
    ro.observe(firstSet);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }

    reducedMotion.addEventListener('change', function (e) {
      e.matches ? disable() : enable();
    });

    function handleVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    document.addEventListener('visibilitychange', handleVisibility);

    return { measure: measure, ro: ro, handleVisibility: handleVisibility };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.handleVisibility) {
      document.removeEventListener('visibilitychange', state.handleVisibility);
    }
  }

  function initSection(section) {
    var state = { marquee: initMarquee(section) };
    sectionState.set(section.id, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section.id);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section.id);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
